module.exports = __webpack_public_path__ + "img/-LV4u--Cl3gxpYoksJeZ.678e2e75.jpg";